module.exports = __webpack_public_path__ + "img/0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b.960dfd0d.png";